export const accountPtBr = {
  nav: {
    profile: 'Perfil',
    preferences: 'Preferências',
    security: 'Segurança',
    apiKeys: 'Chaves de API',
  },
  profile: {
    title: 'Perfil',
    description: 'Informações da sua conta nesta organização',
    name: 'Nome',
    email: 'E-mail',
    tenant: 'Organização',
    readOnlyHint: 'Nome e e-mail são gerenciados pelo provedor de identidade.',
  },
  security: {
    title: 'Segurança',
    description: 'Altere sua senha com um link seguro enviado ao seu e-mail',
    password: 'Senha',
    passwordHelper:
      'Enviaremos um link para definir ou alterar sua senha. Contas que entraram com Google ou Microsoft também podem adicionar login por senha aqui, se a organização permitir no WorkOS.',
    sendResetLink: 'Enviar link de redefinição',
    sending: 'Enviando...',
    successTitle: 'Verifique seu e-mail',
    successBody: 'Enviamos um link para {{email}}. Use-o para definir ou alterar sua senha.',
    successHint:
      'Confira também a pasta de spam ou filtros corporativos. Em ambientes sandbox do WorkOS, o e-mail pode ser suprimido — peça ao administrador para confirmar o envio no painel do WorkOS.',
    legacyTitle: 'Login WorkOS necessário',
    legacyBody:
      'A redefinição de senha está disponível apenas para sessões autenticadas via WorkOS. Faça login novamente com suas credenciais WorkOS.',
    backToDashboard: 'Voltar ao painel',
    errors: {
      network: 'Não foi possível enviar o e-mail. Tente novamente em instantes.',
      generic: 'Não foi possível processar a solicitação. Tente novamente.',
      noEmail: 'Não foi possível identificar o e-mail da sessão.',
      passwordAuthDisabled:
        'Sua organização não permite login por senha (apenas Google, Microsoft ou SSO). Peça ao administrador para habilitar autenticação por senha no WorkOS se precisar desse método.',
      workosUserNotFound:
        'Não encontramos sua conta no WorkOS. Entre em contato com o suporte se o problema persistir.',
      rateLimited: 'Muitas tentativas em sequência. Aguarde alguns minutos e tente novamente.',
    },
  },
  apiKeys: {
    title: 'Chaves de API',
    description: 'Gerencie chaves de API da organização e pessoais para integrações.',
    loading: 'Carregando…',
    loadError: 'Não foi possível carregar o gerenciador de chaves. Tente novamente em instantes.',
    legacyTitle: 'Login WorkOS necessário',
    legacyBody:
      'O gerenciamento de chaves de API está disponível apenas para sessões autenticadas via WorkOS.',
    organization: {
      title: 'Chaves da organização',
      description: 'Crie e revogue chaves de API vinculadas à organização.',
      emptyTitle: 'Nenhuma chave de API ainda',
      emptyMessage: 'Gere uma chave de API para autenticar e interagir com nossa API.',
      noPermission:
        'Você não tem permissão para gerenciar chaves de API da organização. Peça a um administrador para conceder widgets:api-keys:manage no WorkOS.',
    },
    user: {
      title: 'Suas chaves pessoais',
      description: 'Crie e revogue chaves de API vinculadas à sua conta de usuário.',
      noPermission:
        'Você não tem permissão para gerenciar chaves de API pessoais. Peça a um administrador para conceder widgets:user-api-keys:manage-self ou manage-all no WorkOS.',
    },
  },
};

export const accountEn = {
  nav: {
    profile: 'Profile',
    preferences: 'Preferences',
    security: 'Security',
    apiKeys: 'API keys',
  },
  profile: {
    title: 'Profile',
    description: 'Your account information in this organization',
    name: 'Name',
    email: 'Email',
    tenant: 'Organization',
    readOnlyHint: 'Name and email are managed by your identity provider.',
  },
  security: {
    title: 'Security',
    description: 'Change your password using a secure link sent to your email',
    password: 'Password',
    passwordHelper:
      'We will email you a link to set or change your password. Google or Microsoft sign-in users can add a password here when your organization allows it in WorkOS.',
    sendResetLink: 'Send reset link',
    sending: 'Sending...',
    successTitle: 'Check your email',
    successBody: 'We sent a link to {{email}}. Use it to set or change your password.',
    successHint:
      'Also check spam or corporate filters. In WorkOS sandbox environments, email delivery may be suppressed — ask an administrator to confirm delivery in the WorkOS dashboard.',
    legacyTitle: 'WorkOS sign-in required',
    legacyBody:
      'Password reset is only available for sessions signed in via WorkOS. Sign in again with your WorkOS credentials.',
    backToDashboard: 'Back to dashboard',
    errors: {
      network: 'Could not send the email. Please try again shortly.',
      generic: 'Could not process the request. Please try again.',
      noEmail: 'Could not determine the email for this session.',
      passwordAuthDisabled:
        'Your organization does not allow password login (Google, Microsoft, or SSO only). Ask an administrator to enable password authentication in WorkOS if you need it.',
      workosUserNotFound:
        'We could not find your WorkOS account. Contact support if this persists.',
      rateLimited: 'Too many attempts in a row. Wait a few minutes and try again.',
    },
  },
  apiKeys: {
    title: 'API keys',
    description: 'Manage organization and personal API keys for integrations.',
    loading: 'Loading…',
    loadError: 'Could not load the API key manager. Please try again shortly.',
    legacyTitle: 'WorkOS sign-in required',
    legacyBody: 'API key management is only available for sessions signed in via WorkOS.',
    organization: {
      title: 'Organization keys',
      description: 'Create and revoke API keys owned by the organization.',
      emptyTitle: 'No API keys yet',
      emptyMessage: 'Generate an API key to authenticate and interact with our API.',
      noPermission:
        'You do not have permission to manage organization API keys. Ask an administrator to grant widgets:api-keys:manage in WorkOS.',
    },
    user: {
      title: 'Your personal keys',
      description: 'Create and revoke API keys owned by your user account.',
      noPermission:
        'You do not have permission to manage personal API keys. Ask an administrator to grant widgets:user-api-keys:manage-self or manage-all in WorkOS.',
    },
  },
};
